export default __webpack_public_path__ + "static/media/complementary--distance--g2.f24fae54.png";